import type { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AuthFailureGuard, AuthLogoutGuard } from '@evc/platform';
import { ImportAsyncComponent } from '@shared/types/utils.type';

import { Datatype } from '@app/types/datatype.enum';
import { navigationResolver } from '@app/utils/resolvers/navigation.resolver';
import { dataResolver } from './utils/resolvers';

const importPageDrive: ImportAsyncComponent = () =>
  import('./pages/drive/drive').then((m) => m.DriveComponent);

const importPageTrash: ImportAsyncComponent = () =>
  import('./pages/trash/trash').then((m) => m.TrashComponent);

const importPageNotFoundComponent: ImportAsyncComponent = () =>
  import('@shared/components/page-not-found/page-not-found.component').then(
    (m) => m.PageNotFoundComponent,
  );

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'drive',
    resolve: { navigation: navigationResolver },
    pathMatch: 'full',
  },
  {
    path: 'drive',
    data: { id: Datatype.DRIVE, base: 'pages.drive' },
    children: [
      { path: '', loadComponent: importPageDrive, resolve: { data: dataResolver } },
      { path: ':id', loadComponent: importPageDrive, resolve: { data: dataResolver } },
    ],
    resolve: { navigation: navigationResolver },
    canActivate: [MsalGuard],
  },
  {
    path: 'trash',
    data: { id: Datatype.TRASH, base: 'pages.trash', locked: true },
    children: [
      { path: '', loadComponent: importPageTrash, resolve: { data: dataResolver } },
      { path: ':id', loadComponent: importPageTrash, resolve: { data: dataResolver } },
    ],
    resolve: { navigation: navigationResolver },
    canActivate: [MsalGuard],
  },
  {
    path: 'auth-fail',
    canActivate: [AuthFailureGuard],
    loadComponent: importPageNotFoundComponent,
  },
  {
    path: 'logout',
    canActivate: [AuthLogoutGuard],
    loadComponent: importPageNotFoundComponent,
    data: { logout: true },
  },
  {
    path: '**',
    redirectTo: 'drive',
    pathMatch: 'full',
  },
];
